import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { CustomPrice, PricesPatch } from '@/types/pricing';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/**
 * kitchensink binds the body over the stored row, so send only what changed: anything else sent back would undo another
 * user's newer edit. The response is the saved row.
 */
export const patchCustomPrice = async (
  scope: RequestScope,
  { itemId, id, data }: { itemId: number; id: number; data: PricesPatch },
  options: WriteRequestOptions
): Promise<EndpointResponse<CustomPrice>> => {
  try {
    const response = await scopedApi(scope).patch<EndpointResponse<CustomPrice>>(`pricing_item/${itemId}/custom_pricing/${id}`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
